import { render } from "./slidesticky-26.vue?vue&type=template&id=89a4bdb2&scoped=true"
import script from "./slidesticky-26.vue?vue&type=script&lang=js"
export * from "./slidesticky-26.vue?vue&type=script&lang=js"

import "./slidesticky-26.vue?vue&type=style&index=0&id=89a4bdb2&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89a4bdb2"]])

export default __exports__